export const MAX_TICKET_GROUPS_PER_BATCH = 10;
export const MAX_PARALLEL_REQUESTS = 4;
